import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { VelocityTransitionGroup } from 'velocity-react';
import $ from 'jquery';
import NodeHeader from './NodeHeader';

export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.onMouseDown = this.onMouseDown.bind(this);
  }
  onMouseDown(e) {
    const selectedElement = e.target;
    if ($(selectedElement).find('span').hasClass('node-icon-question')) {
      const breadCrumbList = [];
      const parentsList = $($(e.target).closest('li')).parents('.dynamic-tree-node');
      $(parentsList).each((index, item) => {
        breadCrumbList.push($(item).attr('data-path'));
      });
      breadCrumbList.unshift(selectedElement.innerText);
      window.localStorage.setItem('breadCrumb', JSON.stringify(breadCrumbList));
    }
    const toggled = !this.props.node.toggled;
    const onToggle = this.props.onToggle;
    if (onToggle) {
      onToggle(this.props.node, toggled);
    }
  }
  animations() {
    const props = this.props;
    if (props.animations === false) {
      return false;
    }
    const anim = Object.assign({}, props.animations, props.node.animations);
    return {
      toggle: anim.toggle(this.props),
      drawer: anim.drawer(this.props),
    };
  }
  decorators() {
    // Merge Any Node Based Decorators Into The Pack
    const props = this.props;
    const nodeDecorators = props.node.decorators || {};
    return Object.assign({}, props.decorators, nodeDecorators);
  }
  eventBubbles() {
    return { onToggle: this.props.onToggle };
  }
  renderDrawer(decorators, animations) {
    const toggled = this.props.node.toggled;
    if (!animations && !toggled) {
      return null;
    }
    if (!animations && toggled) {
      return this.renderChildren(decorators, animations);
    }
    return (
      <VelocityTransitionGroup
        {...animations.drawer}
        ref={velocity => {
          this.velocity = velocity;
        }}
      >
        {toggled ? this.renderChildren(decorators, animations) : null}
      </VelocityTransitionGroup>
    );
  }
  renderHeader(decorators, animations) {
    return (
      <NodeHeader
        decorators={decorators}
        animations={animations}
        style={this.props.style}
        node={Object.assign({}, this.props.node)}
        onMouseDown={e => this.onMouseDown(e)}
        tabSelected={this.props.tabSelected}
        treeData={this.props.treeData}
        // dataId={`node_${this.props.dataId}`}
      />
    );
  }
  renderChildren(decorators) {
    if (this.props.node.loading) {
      return this.renderLoading(decorators);
    }
    let children = this.props.node.children;
    if (!Array.isArray(children)) {
      children = children ? [children] : [];
    }
    return (
      <ul
        style={this.props.style.subtree}
        ref={subtree => {
          this.subtree = subtree;
        }}
      >
        {children.map((child, index) => (
          <TreeNode
            {...this.eventBubbles()}
            key={child.id || index}
            node={child}
            decorators={this.props.decorators}
            animations={this.props.animations}
            style={this.props.style}
            tabSelected={this.props.tabSelected}
            treeData={this.props.treeData}
            dataId={child.shortText}
          />
        ))}
      </ul>
    );
  }
  renderLoading(decorators) {
    return (
      <ul style={this.props.style.subtree}>
        <li>
          <decorators.Loading style={this.props.style.loading} />
        </li>
      </ul>
    );
  }
  render() {
    const decorators = this.decorators();
    const animations = this.animations();
    return (
      <li
        style={this.props.style.base}
        ref={topLevel => {
          this.topLevel = topLevel;
        }}
        data-path={this.props.dataId}
        data-uniqueId={`nodeID_${this.props.node.uniqueId}`}
        className="dynamic-tree-node"
      >
        {this.renderHeader(decorators, animations)}
        {this.renderDrawer(decorators, animations)}
      </li>
    );
  }
}

TreeNode.propTypes = {
  style: PropTypes.shape({
    base: PropTypes.shape({}),
    link: PropTypes.shape({}),
    activeLink: PropTypes.shape({}),
    toggle: PropTypes.shape({}),
    header: PropTypes.shape({}),
    subtree: PropTypes.shape({}),
    loading: PropTypes.shape({}),
  }).isRequired,
  node: PropTypes.shape({
    toggled: PropTypes.bool,
    loading: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  decorators: PropTypes.shape({}).isRequired,
  animations: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
    .isRequired,
  onToggle: PropTypes.func,
  tabSelected: PropTypes.string,
  treeData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  dataId: PropTypes.string,
};
